import { getTime, format } from 'date-fns'
import { ru } from 'date-fns/esm/locale'
import i18n from '../i18n'
import { toast } from 'react-toastify'

export function regexLogin(str) {
	if (str) {
		return str.toLowerCase().replace(/[^a-z0-9_]/gi, '');
	}
	return ''
}

export function deleteSymbols(str) {
	if (str) {
		return str.replace(/[^A-Z0-9]/gi, '');
	}
	return ''
}

export function regexNumeric(str) {
	if (str) {
		return str.replace(/[^0-9.]/gi, '');
	}
	return ''
}

export function returnSign(str) {
	return str.includes('?') ? '&' : '?'
}

export function arrayJoin(arr, arrayOfObjects = true) {
	if (arrayOfObjects) {
		return arr.map(u => u.id).join(',')
	}

	return arr.join()
}

/**
 * Статус заявки внешней службы доставки (Яндекс, Uzum, Noor…) по коду из
 * cheques_courier_status: ключ перевода и цвет. -10/1 — заявка ушла, курьера ищут;
 * 2 найден; 3–4 у заведения; 5 везёт; 6 доставлено; -1 заявку сняли.
 * Статуса ещё нет — заявка только отправлена, это тоже «ищем».
 */
export function externalCourierStatus(status) {
	const value = status === null || status === undefined ? null : Number(status)

	if (value === 2) return { key: 'ext_courier_found', color: 'text-primary' }
	if (value === 3 || value === 4) return { key: 'ext_courier_at_pos', color: 'text-primary' }
	if (value === 5) return { key: 'ext_courier_picked_up', color: 'text-primary' }
	if (value === 6) return { key: 'ext_courier_delivered', color: 'text-success' }
	if (value === -1) return { key: 'ext_courier_cancelled', color: 'text-danger' }

	return { key: 'ext_courier_searching', color: 'text-warning' }
}

export function regexPhoneNumber(str) {
	if (!str) {
		return "";
	}

	const cleanDigits = str.replace(/\D/g, ''); // Удаляем все, кроме цифр

	if (cleanDigits.length === 0) {
		return "";
	}

	// Определяем формат в зависимости от длины номера
	// Эти форматы являются эвристическими и подходят для номеров 10-12 цифр
	// Если у вас есть другие стандартные длины, добавьте их.

	switch (cleanDigits.length) {
		case 12: // Например, Узбекистан (998901234567) или Турция (905321234567)
			// Формат: XXX XX XXX-XX-XX
			// Пример: 998 90 123-45-67
			if (cleanDigits.startsWith('998') || cleanDigits.startsWith('90')) {
				const code = cleanDigits.substring(0, 3); // Код страны
				const operator = cleanDigits.substring(3, 5); // Код оператора/региона
				const part1 = cleanDigits.substring(5, 8);
				const part2 = cleanDigits.substring(8, 10);
				const part3 = cleanDigits.substring(10, 12);
				return `${code} ${operator} ${part1}-${part2}-${part3}`;
			}
			// Если 12 цифр, но не начинается с 998/90 (например, США с 1)
			// Можно добавить свои правила или оставить как общий случай
			return cleanDigits.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, "$1 $2 $3 $4"); // Пример 123 456 789 012

		case 11: // Например, Россия (79031234567)
			// Формат: X (XXX) XXX-XX-XX
			// Пример: 7 (903) 123-45-67
			if (cleanDigits.startsWith('7') && cleanDigits.length === 11) {
				const code = cleanDigits.substring(0, 1); // Код страны (7)
				const area = cleanDigits.substring(1, 4); // Код региона/оператора
				const part1 = cleanDigits.substring(4, 7);
				const part2 = cleanDigits.substring(7, 9);
				const part3 = cleanDigits.substring(9, 11);
				return `${code} (${area}) ${part1}-${part2}-${part3}`;
			}
			return cleanDigits.replace(/(\d{3})(\d{3})(\d{2})(\d{3})/, "$1 $2 $3 $4"); // Пример 11 цифр 123 456 78 901

		case 10: // Например, мобильный без кода страны (если такой формат принят)
			// Формат: (XXX) XXX-XX-XX (если это локальный номер)
			// Пример: (903) 123-45-67
			const area = cleanDigits.substring(0, 3);
			const part1 = cleanDigits.substring(3, 6);
			const part2 = cleanDigits.substring(6, 8);
			const part3 = cleanDigits.substring(8, 10);
			return `(${area}) ${part1}-${part2}-${part3}`;

		case 7: // Городской номер
			// Формат: XXX-XX-XX
			// Пример: 123-45-67
			const p1 = cleanDigits.substring(0, 3);
			const p2 = cleanDigits.substring(3, 5);
			const p3 = cleanDigits.substring(5, 7);
			return `${p1}-${p2}-${p3}`;

		// Добавьте другие кейсы по мере необходимости для специфических длин

		default:
			// Если длина не соответствует известным шаблонам,
			// просто разбиваем на группы по 3-4 цифры, что хоть как-то читабельно.
			// Это очень общий случай.
			return cleanDigits.replace(/(\d{3})(?=\d)/g, '$1 '); // Каждые 3 цифры, затем пробел
	}
}

export function clearTemporaryStorage() {
	localStorage.removeItem('login')
	localStorage.removeItem('role')
	localStorage.removeItem('token')
}

export function findKeyFromArrayByValue(array, valueName, value, key) {
	if ((array.length > 0 && value) || value === 0) {
		var found = array.find(x => x[valueName] === value)
		return found ? found[key] : '';
	}
}

export function formatMoneyInput(amount) {
	if (!amount) return ""
	return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function formatMoney(amount, decimalCount = 0, decimal = ".", thousands = " ") {
	if (!amount) {
		return 0
	}

	if (Number.isInteger(Number(amount))) {
		decimalCount = 0
	}

	try {
		decimalCount = Math.abs(decimalCount);
		decimalCount = isNaN(decimalCount) ? 0 : decimalCount; // 0 was 2

		const negativeSign = amount < 0 ? "-" : "";

		let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
		let j = (i.length > 3) ? i.length % 3 : 0;

		return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
	} catch (e) {
		console.log(e)
	}
}

export function formatDate(date, formating = 'dd.MM.yyyy') {
	if (date) {
		var formattedDate = format(new Date(date), formating);
		return formattedDate
	}
}

export function newDate(format = 'yyyy-MM-dd') {
	return format(new Date(), format)
}

export function formatDateCalendar(date) {
	if (date) {
		var formattedDate = format(new Date(date), 'dd MMMM yyyy', { locale: ru });
		return formattedDate
	}
}

export function getUnixTime() {
	return getTime(new Date())
}

export function getUnixTimeByDate(date) {
	return getTime(date)
}

export function formatUnixTime(unixTime) {
	if (unixTime)
		return format(new Date(unixTime), 'dd.MM.yyyy HH:mm:ss')
}

export function sumFromArray(array, key) {
	var sum = 0
	if (array && array.length > 0) {
		for (let i = 0; i < array.length; i++) {
			sum += Number(array[i][key]);
		}
	}

	return sum
}

export function returnMinDate(date, days) {
	var result = new Date(date);
	result.setDate(result.getDate() - days);
	return result;
}

export function countTotalFromArray(array = [], key) {
	var count = 0

	if (array?.length > 0) {
		for (let i = 0; i < array.length; i++) {
			count += Number(array[i][key])
		}
	}
	return count
}

export function generateTransactionId(posId, userId) {
	if (posId && userId)
		return posId.toString() + userId.toString() + getUnixTime().toString() + Math.floor(Math.random() * 999999)
}

export function copyText(text) {
	navigator.clipboard.writeText(text)
}

export function notify(message, type = 'error') {
	toast.dismiss()
	if (type === 'error')
		toast.error(message)
	if (type === 'success')
		toast.success(message)
}

export const PAGE_SIZES = [
	{ id: 20, name: '20' },
	{ id: 50, name: '50' },
	{ id: 100, name: '100' }
];

export function filterDates(type = 'today') {
	const today = new Date();
	let newStartDate = null;
	let newEndDate = null;

	const getStartOfWeek = (date) => {
		const d = new Date(date);
		const day = d.getDay();
		const diff = d.getDate() - day + (day === 0 ? -6 : 1);
		return new Date(d.setDate(diff));
	};

	const getEndOfWeek = (date) => {
		const d = new Date(date);
		const startOfWeek = getStartOfWeek(d);
		const endOfWeek = new Date(startOfWeek);
		endOfWeek.setDate(startOfWeek.getDate() + 6);
		return endOfWeek;
	};

	switch (type) {
		case 'today':
			newStartDate = formatDate(today, 'yyyy-MM-dd');
			newEndDate = formatDate(today, 'yyyy-MM-dd');
			break;
		case 'currentWeek':
			const startOfCurrentWeek = getStartOfWeek(today);
			const endOfCurrentWeek = getEndOfWeek(today);
			newStartDate = formatDate(startOfCurrentWeek, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfCurrentWeek, 'yyyy-MM-dd');
			break;
		case 'currentMonth':
			const startOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
			const endOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
			newStartDate = formatDate(startOfCurrentMonth, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfCurrentMonth, 'yyyy-MM-dd');
			break;
		case 'currentYear':
			const startOfCurrentYear = new Date(today.getFullYear(), 0, 1);
			const endOfCurrentYear = new Date(today.getFullYear(), 11, 31);
			newStartDate = formatDate(startOfCurrentYear, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfCurrentYear, 'yyyy-MM-dd');
			break;
		case 'yesterday':
			const yesterday = new Date(today);
			yesterday.setDate(today.getDate() - 1);
			newStartDate = formatDate(yesterday, 'yyyy-MM-dd');
			newEndDate = formatDate(yesterday, 'yyyy-MM-dd');
			break;
		case 'lastWeek':
			const lastWeekEnd = new Date(today);
			lastWeekEnd.setDate(today.getDate() - 7);
			const startOfLastWeek = getStartOfWeek(lastWeekEnd);
			const endOfLastWeek = getEndOfWeek(lastWeekEnd);
			newStartDate = formatDate(startOfLastWeek, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfLastWeek, 'yyyy-MM-dd');
			break;
		case 'lastMonth':
			const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
			const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
			newStartDate = formatDate(startOfLastMonth, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfLastMonth, 'yyyy-MM-dd');
			break;
		case 'lastYear':
			const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
			const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
			newStartDate = formatDate(startOfLastYear, 'yyyy-MM-dd');
			newEndDate = formatDate(endOfLastYear, 'yyyy-MM-dd');
			break;
		default:
			newStartDate = null;
			newEndDate = null;
			break;
	}

	return {
		'start_date': newStartDate,
		'end_date': newEndDate,
	}
}

export const FILTER_DATE = [
	{ 'id': 'today', 'name': i18n.t('today') },
	{ 'id': 'yesterday', 'name': i18n.t('yesterday') },
	{ 'id': 'currentWeek', 'name': i18n.t('current_week') },
	{ 'id': 'lastWeek', 'name': i18n.t('last_week') },
	{ 'id': 'currentMonth', 'name': i18n.t('current_month') },
	{ 'id': 'lastMonth', 'name': i18n.t('last_month') },
];